import { Typography } from "@/design-system/Atoms"; 

type VendorInformationLayoutProps = {
  heading?: string;
  content?: string | React.ReactNode;
  className?: string;
};

export const VendorInformationLayout = ({
  heading,
  content,
  className,
}: VendorInformationLayoutProps) => {
  return (
    <>
      <Typography
        variant="privacyPolicyTitle"
        as="div"
        className={`${className}`}
      >
        {heading}
      </Typography>

      <Typography variant="privacyPolicyDescription" as="p">
        {content}
      </Typography>
    </>
  );
};

export default VendorInformationLayout;
